import { type ReactNode } from 'react';

export const PAGE_HEAD =
  'font-display text-3xl sm:text-4xl font-bold tracking-tight text-text-primary';
export const SECTION_HEAD =
  'font-display text-xl sm:text-2xl font-bold tracking-tight text-text-primary';
export const SUBSECTION_HEAD =
  'text-sm sm:text-base font-semibold uppercase tracking-[0.16em] text-brand-red';
export const BODY = 'text-sm leading-relaxed text-text-secondary';
export const LEAD = 'text-sm sm:text-base leading-relaxed text-text-primary';
export const UL = `${BODY} space-y-1.5`;
export const STAT_VALUE =
  'font-display text-2xl sm:text-3xl font-bold tracking-tight text-text-primary';
export const STAT_LABEL =
  'text-[11px] uppercase tracking-[0.14em] text-text-tertiary';

export function Section({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}): ReactNode {
  return (
    <section className="space-y-sm">
      <h2 className={SECTION_HEAD}>{title}</h2>
      <div className="space-y-sm">{children}</div>
    </section>
  );
}

export function Subsection({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}): ReactNode {
  return (
    <div className="space-y-xs">
      <h3 className={SUBSECTION_HEAD}>{title}</h3>
      {children}
    </div>
  );
}

export function Divider(): ReactNode {
  return <hr className="border-white/[0.06]" />;
}

export function Card({ children }: { children: ReactNode }): ReactNode {
  return (
    <div className="rounded-lg border border-white/[0.06] bg-surface-elevated/40 p-base sm:p-lg">
      {children}
    </div>
  );
}

export function Stat({
  value,
  label,
}: {
  value: string;
  label: string;
}): ReactNode {
  return (
    <div className="space-y-1">
      <p className={STAT_VALUE}>{value}</p>
      <p className={STAT_LABEL}>{label}</p>
    </div>
  );
}

export function PullQuote({ children }: { children: ReactNode }): ReactNode {
  return (
    <p className="border-l-2 border-brand-red pl-base text-sm italic leading-relaxed text-text-primary">
      {children}
    </p>
  );
}

export function Bullet({ children }: { children: ReactNode }): ReactNode {
  return (
    <li className="relative pl-base before:absolute before:left-0 before:top-2 before:h-1 before:w-1 before:rounded-full before:bg-brand-red">
      {children}
    </li>
  );
}
